export default __webpack_public_path__ + "static/media/dashboard.53230cba.svg";